import { Directive, ElementRef, HostListener, Input, OnInit, Optional, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

import { NumberHelperService } from '@mirage-projects/cw-utils';

/**
 * Directive to round the value of an input to a specific number of decimals
 * It will round the value on blur and show the original value on focus
 * The value in the formControl will be the original value
 */
@Directive({
    selector: 'input[cwNumberDecimals]',
    standalone: false,
})
export class NumberDecimalsDirective implements OnInit {
    /**
     * The number of decilmals to show
     */
    @Input() decimals = 2;

    private originalValue: number | undefined;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        @Optional() private control: NgControl,
        private numberHelperService: NumberHelperService
    ) {}

    ngOnInit(): void {
        this.onBlur();
    }

    /**
     * Set the original value on focus
     */
    @HostListener('focus')
    onFocus(): void {
        if (this.control && this.originalValue !== undefined) {
            this.renderer.setProperty(this.el.nativeElement, 'value', this.originalValue);
        }
    }

    /**
     * Round the value on blur
     */
    @HostListener('blur')
    onBlur(): void {
        if (this.control) {
            const value = parseFloat(this.control.value);
            if (!isNaN(value)) {
                this.originalValue = value;
                const rounded = Number(this.round(value, this.decimals));
                this.renderer.setProperty(this.el.nativeElement, 'value', rounded);
            }
        }
    }

    private round(value: number, decimals: number): number {
        const res = this.numberHelperService.toFixedWithPrecision(Number(value), decimals);
        return Number(res);
    }
}
